import React, { useEffect, useState } from 'react';
import { Form, Row, Col } from 'antd';
import { FieldArray, Field } from 'formik';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getOptionsByPath } from '../../../utilsdata';
import { InputField, DatePickerField, SelectInput } from '../../../blueplanitUtils/InputField';
import { EXISTING_POLICY_INFO, REQUEST_PERSONAL_LINE, COMMERCIAL_POLICY_INFO, COMMERCIAL_LINE, CURRENT_CARRIER } from '../../../Dropdownmanager';


const ExistingPolicyInformation = (props) => {
  const { handleChange, values, handleBlur } = props;

  const [policyNumber, setPolicyNumber] = useState([]);

  const [currentPremium, setCurrentPremium] = useState([]);

  useEffect(() => {
    if (values.existingPolicyInformation) {
      setPolicyNumber(values.existingPolicyInformation.map(policy => policy.policyNumber));
    }
  }, [values.existingPolicyInformation]);

  useEffect(() => {
    if (values.existingPolicyInformation) {
      setCurrentPremium(values.existingPolicyInformation.map(policy => policy.currentPremium));
    }
  }, [values.existingPolicyInformation]);

  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
  const commercialOptions = getOptionsByPath(NestedDatabucket, [COMMERCIAL_POLICY_INFO, COMMERCIAL_LINE]);
  const personalOptions = getOptionsByPath(NestedDatabucket, [EXISTING_POLICY_INFO, REQUEST_PERSONAL_LINE]);



  const handleDeleteRow = (index, arrayHelpers) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this existingPolicyInformation?");
    if (confirmDelete) {
      arrayHelpers.remove(index);
      setPolicyNumber((prevPolicyNumbers) => prevPolicyNumbers.filter((_, i) => i !== index));
      setCurrentPremium((prevCurrentPremium) => prevCurrentPremium.filter((_, i) => i !== index));
    }
  };

  const handleAddRow = (arrayHelpers) => {
    arrayHelpers.push({
      currentCarrier: '',
      propertyType: '',
      propertyNew: '',
      policyNumber: '',
      effectiveDate: null,
      currentPremium: ''
    });

    setPolicyNumber((prevPolicyNumbers) => [...prevPolicyNumbers, '']);
    setCurrentPremium((prevCurrentPremium) => [...prevCurrentPremium, '']);
  };

  const handleKeyDown = (e) => {
    let value = e.target.value.replace(/[^\d/]/g, '');

    if (value.length >= 10 && e.key !== "Backspace") {
      e.preventDefault();
      return;
    }

    value = value
      .replace(/^(\d{2})(\d)$/g, '$1/$2')
      .replace(/^(\d{2}\/\d{2})(\d{1,4})$/g, '$1/$2');

    e.target.value = value;
  };

  return (
    <div className="row">
      <Form layout="vertical">
        <h5 className="card-title" style={{ fontWeight: 'bold' }}>Existing Policy Information</h5>
        <div className="mb-3">
          <hr />
        </div>
        <FieldArray
          name="existingPolicyInformation"
          render={(arrayHelpers) => (
            <>
              {values?.existingPolicyInformation?.map((policy, index) => (
                <div key={index} className="existing-policy-wrapper">

                  {/* MAIN POLICY CONTENT */}
                  <Row className="existing-policy-row" gutter={[12, 12]}>

                    {/* LEFT COLUMN */}
                    <Col span={12}>
                      <div className="policy-field-row" style={{ marginTop: '5px', marginLeft:'5px' }}>
                        <span className="policy-label" style={{ marginTop: '-20px', marginRight:'-5px' }}>Policy Type</span>
                        <div className="policy-input">
                          <SelectInput
                            label=""
                            name={`existingPolicyInformation.${index}.propertyType`}
                            value={policy.propertyType}
                            onChange={(value) =>
                              handleChange({
                                target: {
                                  name: `existingPolicyInformation.${index}.propertyType`,
                                  value
                                }
                              })
                            }
                            options={
                              (values.processType === 'Policy Quoting' &&
                                values.department === 'Commercial Lines')
                                ? commercialOptions
                                : personalOptions
                            }
                          />
                        </div>
                      </div>

                      <div className="policy-field-row" style={{ marginTop: '-18px', marginLeft:'5px' }}>
                        <span className="policy-label" style={{ marginTop: '-20px' }}>Current Carrier</span>
                        <div className="policy-input">
                          <SelectInput
                            label=""
                            name={`existingPolicyInformation.${index}.currentCarrier`}
                            value={policy.currentCarrier}
                            onChange={(value) =>
                              handleChange({
                                target: {
                                  name: `existingPolicyInformation.${index}.currentCarrier`,
                                  value
                                }
                              })
                            }
                            onBlur={handleBlur}
                            options={getOptionsByPath(
                              NestedDatabucket,
                              [EXISTING_POLICY_INFO, CURRENT_CARRIER]
                            )}
                          />
                        </div>
                      </div>

                      <div className="policy-field-row" style={{ marginTop: '-18px',  marginLeft:'5px' }}>
                        <span className="policy-label">Policy Number</span>
                        <div className="policy-input">
                          <InputField
                            label=""
                            type="number"
                            value={policyNumber[index] || ''}
                            onChange={(e) => {
                              const updated = [...policyNumber];
                              updated[index] = e.target.value;
                              setPolicyNumber(updated);
                            }}
                            onBlur={(e) =>
                              handleChange({
                                target: {
                                  name: `existingPolicyInformation[${index}].policyNumber`,
                                  value: e.target.value
                                }
                              })
                            }
                          />
                        </div>
                      </div>
                    </Col>

                    {/* RIGHT COLUMN */}
                    <Col span={12}>
                      <div className="policy-field-row" style={{ marginTop: '5px' }}>
                        <span className="policy-label" style={{ marginRight: '-25px', marginTop: '-20px' }}>
                          Effective Date
                        </span>
                        <div className="policy-input" style={{ marginLeft: '20px' }}>
                          <Field name={`existingPolicyInformation.${index}.effectiveDate`}>
                            {({ field }) => (
                              <DatePickerField
                                label=""
                                name={field.name}
                                value={field.value ? dayjs(field.value) : null}
                                onChange={(date) =>
                                  field.onChange({
                                    target: { name: field.name, value: date }
                                  })
                                }
                                allowClear={false}
                                format="DD/MM/YYYY"
                              />
                            )}
                          </Field>
                        </div>
                      </div>

                      <div className="policy-field-row" style={{ marginTop: '-15px' }}>
                        <span className="policy-label" style={{ marginLeft: '10px' }}>
                          Current Premium
                        </span>
                        <div className="policy-input" style={{ marginLeft: '20px' }}>
                          <InputField
                            label=""
                            value={currentPremium[index] || ''}
                            onChange={(e) => {
                              const updated = [...currentPremium];
                              updated[index] = e.target.value;
                              setCurrentPremium(updated);
                            }}
                            onBlur={(e) =>
                              handleChange({
                                target: {
                                  name: `existingPolicyInformation[${index}].currentPremium`,
                                  value: e.target.value
                                }
                              })
                            }
                          />
                        </div>
                      </div>
                    </Col>

                  </Row>

                  {/* DELETE ROW (SEPARATE & BELOW) */}
                  <div className="existing-policy-delete-row">
                    <Link
                      to="#"
                      className="delete-icon"
                      onClick={() => handleDeleteRow(index, arrayHelpers)}
                    >
                      <i className="fa-regular fa-trash-can" />
                    </Link>
                  </div>

                </div>
              ))}


              {/* Add More link */}
              <Form.Item className="form-item-add-more">
                <Link to="#" onClick={() => handleAddRow(arrayHelpers)} style={{ fontSize:'12px'}}>
                  <i className="fa-solid fa-plus-circle" /> Add More
                </Link>
              </Form.Item>
            </>
          )}
        />
      </Form>
    </div>

  );
};

export default ExistingPolicyInformation;

